import type { ThemeTokens } from "@yamada-ui/core"

export const radii: ThemeTokens = {
  base: "0.25rem",
  sm: "0.125rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px",
  none: "0",
}
